import {
    CONTRACTS_WITH_FILTERS
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case CONTRACTS_WITH_FILTERS:
        return action.payload
      default:
        return state
    }
  }
